import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import TableauComponents from '../../../components/tableau/TableauComponents'
import ModalCreate from '../../../components/modals/ModalCreate'
import { v4 as uuid } from 'uuid'

function AdminData({titre, actionCreate, colonnes, data, actionEdit, fetchData, actionDelete}) {
    const dispatch = useDispatch()
    const [openModalCreate, setOpenModalCreate] = useState(false)
    const [updateView, setUpdateView] = useState(false)
    
    useEffect(()=>{
       dispatch(fetchData());
       setUpdateView(false)
    }, [titre, updateView]);

    const openModalHandler = () => {
        setOpenModalCreate(true)
    }

    return (
        <div className='mx-2'>

            <div className='flex flex-row justify-between'>
                <h3 className='text-xl font-bold uppercase text-orange-800'>{titre}</h3>
                <button 
                    className="bg-orange-400 text-white px-6 py-2 rounded-xl hover:bg-orange-600 transition"
                    onClick={openModalHandler}>
                        + Ajout d'un {titre}
                </button>
            </div>
            <div className='my-2'>
                <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    {<TableauComponents key={uuid()} titre={titre} colonnes={colonnes} 
                    data={data} actionEdit={actionEdit} actionDelete={actionDelete}
                    setUpdateView={setUpdateView} />}
                </div>
            </div>

            <ModalCreate
                    key={uuid()}
                    titre={titre} 
                    isOpen={openModalCreate}
                    setIsOpen={setOpenModalCreate}
                    fields={colonnes}
                    actionCreate={actionCreate}
                    setUpdateView={setUpdateView}/>
        </div>
  )
}

export default AdminData;